module.exports = __webpack_public_path__ + "img/giftcert-desktop.a4f9161.svg";